import styled from 'styled-components';

export default styled.div`
  width: ${props => props.progress || 0}%;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: ${props => (props.isLive ? '#FF6256' : 'rgba(72, 53, 198, 1)')};
  border-radius: 0.3rem;
  ${props => !props.transitionDisabled && 'transition: width 250ms linear;'}
`;
